import { countries } from '../const/countries';
import h from "./htm";

export default ({ label = '', required = false, type = '', key = '', value = '', apiAddress = '', group, checked, options, children, servercountries, placeholder, requiredtype, invalidMessage }) => {

	const argsRef = { key, label, placeholder };

	const fieldCountries = servercountries ? servercountries : countries;

	function getRequiredDealer() {
		const msg = invalidMessage ? ` invalidmessage="${invalidMessage}"` : '';
		return h(
			`div dealer-selector name="selDealer" id="selDealer" class="dealer" api-address="${apiAddress}" validate="onsubmit" requiredType="dealer"${msg}"`,
			h('header class="expanded"', 'Select My Dealer *')
				('section',
					h('div specific',
						h('input id="DealerLocation" name="DealerLocation" location placeholder="City or Address"')
							('span use-location')
							('input type="hidden" name="DealerCode" id="DealerCode"')
							('input type="hidden" name="Dealer[address]" class="validate" placeholder="Select My Dealer"')
							('input type="hidden" name="Dealer[city]"')
							('input type="hidden" name="Dealer[state]"')
							('input type="hidden" name="Dealer[email]"')
							('input type="hidden" name="Dealer[name]"')
							('input type="hidden" name="Dealer[phone]"')
							('input type="hidden" name="Dealer[zip]"')
							('input type="hidden" name="Dealer[isInternational]"')
							('input type="hidden" name="Dealer[website]"')
							('input type="hidden" name="Dealer[distance]"')
					)
						('div errors')
						('div dealers')
				)
		);
	}

	function getRequiredElement(requiredType) {
		if (!requiredType)
			requiredType = requiredtype;

		const msg = invalidMessage ? ` invalidmessage="${invalidMessage}"` : '';

		return `input id="${key}" name="${key}" type="text" value="${value}" placeholder="${placeholder}" validate="onsubmit" requiredType="${requiredType}"${msg}`;
	}

	function getRequiredLocationFromPostal() {
		let pcInvalidMessage = '';
		let ctryInvalidMessage = '';
		if (invalidMessage) {
			let pcMsg = invalidMessage;
			let ctryMsg = invalidMessage;
			const x1 = invalidMessage.indexOf('[');
			const x2 = invalidMessage.indexOf(']');
			if (x1 > -1 && x2 > -1) {
				const msgKey = invalidMessage.substring(x1 + 1, x2);

				if (argsRef[msgKey]) {
					pcMsg = pcMsg.replace(`[${msgKey}]`, `${argsRef[msgKey]} Postal Code`);
					ctryMsg = ctryMsg.replace(`[${msgKey}]`, `${argsRef[msgKey]} Country`);
				}
			}
			pcInvalidMessage = ` invalidmessage="${pcMsg}"`;
			ctryInvalidMessage = ` invalidmessage="${ctryMsg}"`;
		}

		const postalCode = `input type="text" id="${key}ZipCode" name="${key}ZipCode" placeholder="${label} Postal Code *" validate="onsubmit" requiredType="postalcode"${pcInvalidMessage}`;
		const select = `select id="${key}Country" name="${key}Country" placeholder="${label} Country *" validate="onsubmit" requiredType="sel"${ctryInvalidMessage}`;
		const defaultOption = `option value="" disabled selected`;
		const options = fieldCountries.reduce((html, { code, name }) => html + h('option value="' + code + '"', name), '');

		return h(
			`div location-from-postal="${key}"`,
			h(postalCode)
		)('div',
			h(select,
				h(defaultOption, `${label} Country *`) + options)
		)
			('input type="hidden" name="' + key + 'City"')
			('input type="hidden" name="' + key + 'State"');
	}

	function getRequiredSelect() {

		const selOptions = typeof options === 'string'
			? options.split(',')
			: options;

		const fnGetOptionItem = (item) => {
			if (typeof item === 'string')
				return h(`option value="${item}"`, item);

			return h(`option value="${item.label}" ` + writeOptions(item), item.label);
		};

		const writeOptions = (item) => {
			if (item.children) {
				return children.split(',').reduce((str, childItem) => {
					return `${str} ${childItem}="${item.children[childItem]}"`;
				}, '');
			}
			return '';
		}

		const msg = invalidMessage ? ` invalidmessage="${invalidMessage}"` : '';

		return h('div',
			h(`select id="${key}" name="${key}" placeholder="${placeholder}" children="${children}" validate="onsubmit" requiredType="sel"${msg}`,
				h('option value="" disabled selected', placeholder) +
				selOptions.reduce((html, optionItem) => {
					return html + fnGetOptionItem(optionItem);
				}, '')
			)
		);
	}

	if (type === 'break') return '<hr>';

	return h('div field', (() => {
		switch (type) {
			case 'dealer-required':
				return getRequiredDealer();

			case 'email-required':
				return h('div', h(getRequiredElement('email')));

			case 'locationFromPostal-required':
				return getRequiredLocationFromPostal();

			case 'num8-pattern':
				return h('div', h(getRequiredElement('num8Pattern')));

			case 'select-required':
				return getRequiredSelect();

			case 'tel-required':
				return h('div', h(getRequiredElement('tel')));

			case 'text':
			case 'text-required':
				return h('div', h(getRequiredElement(requiredtype)));

			case 'state':
				return h('div', h(getRequiredElement('state'))); 

			case 'email':
			case 'number':
			case 'hidden':
				return h('div', h('input id="' + key + '" name="' + key + '" type="' + type + '" class="' + (required ? 'validate' : '') + '" placeholder="' + label + (required ? ' *' : '') + '" value="' + (value || '') + '"'));
			case 'num8':
				return h('div', h('input id="' + key + '" name="' + key + '" type="text" pattern="^[0-9]{8}$" class="' + (required ? 'validate' : '') + '" placeholder="' + label + (required ? ' *' : '') + '" value="' + (value || '') + '"'));
			case 'tel':
				return h('div type="' + type + '"',
					h('input id="' + key + '" name="' + key + '" type="' + type + '" class="' + (required ? 'validate' : '') + '" placeholder="' + label + (required ? ' *' : '') + '" value="' + (value || '') + '"')
						('input type="tel" name="PhoneExtension" placeholder="Ext."')
				);
			case 'textarea':
				return h('div', h('textarea id="' + key + '" name="' + key + '" validate="onsubmit" requiredtype="' + requiredtype + '" placeholder="' + label + (required ? ' *' : '') + '"'));
			case 'select':
				return h('div',
					h('select id="' + key + '" name="' + key + '" class="' + (required ? 'validate' : '') + '" placeholder="' + label + '"' + (children ? ' children="' + children + '"' : ''),
						h(label ? 'option value="" disabled selected' : '', label) +
						(typeof options === 'string' ? options.split(',') : options).reduce((html, optionItem) => {
							return html + (typeof optionItem === 'string' ? h('option value="' + optionItem + '"', optionItem) : h('option value="' + optionItem.label + '" ' + (optionItem.children ? children.split(',').reduce((str, childItem) => {
								return str + ' ' + childItem + '="' + optionItem.children[childItem] + '"';
							}, '') : '') + '', optionItem.label));
						}, '')
					)
				);
			case 'country':

				return h('div',
					h('select id="' + key + '" name="' + key + '" class="' + (required ? 'validate' : '') + '" placeholder="' + label + '"' + (children ? ' children="' + children + '"' : ''),
						h(label ? 'option value="" disabled selected' : '', label) +
						fieldCountries.reduce((html, { code, name }) => html + h('option value="' + code + '"', name), '')
					)
				);
			case 'locationFromPostal':
				return h('div location-from-postal="' + key + '"',
					h('input id="' + key + 'ZipCode" name="' + key + 'ZipCode" class="' + (required ? 'validate' : '') + '" placeholder="' + label + ' Postal Code ' + (required ? '*' : '') + '" type="text"')
				)('div',
					h('select id="' + key + 'Country" name="' + key + 'Country" class="' + (required ? 'validate' : '') + '" placeholder="' + label + ' Country ' + (required ? '*' : '') + '"',
						h(label ? 'option value="" disabled selected' : '', label + ' Country ' + (required ? '*' : '')) +
						fieldCountries.reduce((html, { code, name }) => html + h('option value="' + code + '"', name), '')
					)
				)
					('input type="hidden" name="' + key + 'City"')
					('input type="hidden" name="' + key + 'State"');
			case 'check':
				return h('div',
					h('input type="checkbox" class="filled-in" id="' + key + '" name="' + (group ? group + '[]' : key) + '" value="' + (group ? key : 'true') + '"' + (checked ? ' checked="checked"' : ''))
						('label for="' + key + '"', label)
				);
			case 'checkLocation':
				return h('div location-check',
					h('input type="checkbox" class="filled-in" id="' + key + '" name="' + (group ? group + '[]' : key) + '" value="' + (group ? key : 'true') + '"' + (checked ? ' checked="checked"' : ''))
						('label for="' + key + '"', label + (required ? ' *' : ''))
						('section',
							h('div specific',
								h('input location placeholder="Mailing Address *" type="text"')
							)
								('div class="errors"')
								('div international',
									h('h6', 'Please make sure this address is correct:')
										('textarea name="InternationalAddress" placeholder="Enter your international address"')
								)
								('div national',
									h('input name="Address2" type="text" placeholder="Apartment / Suite (optional)"')
								)
								('input type="hidden" name="Address"')
								('input type="hidden" name="City"')
								('input type="hidden" name="State"')
								('input type="hidden" name="PostalCode"')
								('input type="hidden" name="Country"')
						)
				);
			case 'dealer':
				return h('div dealer-selector class="dealer" api-address="' + apiAddress + '"',
					h('header class="expanded"', 'Select My Dealer' + (required ? ' *' : ''))
						('section',
							h('div specific',
								h('input location placeholder="City or Address"')
									('span use-location')
									('input type="hidden" name="DealerCode"')
									('input type="hidden" name="Dealer[address]" class="validate" placeholder="Select My Dealer"')
									('input type="hidden" name="Dealer[city]"')
									('input type="hidden" name="Dealer[state]"')
									('input type="hidden" name="Dealer[email]"')
									('input type="hidden" name="Dealer[name]"')
									('input type="hidden" name="Dealer[phone]"')
									('input type="hidden" name="Dealer[zip]"')
									('input type="hidden" name="Dealer[isInternational]"')
									('input type="hidden" name="Dealer[website]"')
									('input type="hidden" name="Dealer[distance]"')
							)
								('div errors')
								('div dealers')
						)
				);
			default:
				return '';
		}
	})());
};